import React from "react";
import { motion } from "framer-motion";

const WhyChooseUs = () => {
  return (
    <section className="relative bg-[#0A1620] overflow-hidden py-20 lg:py-24">
      {/* Dark Theme Background */}
      <div className="absolute inset-0 bg-[#0A1620]"></div>

      {/* Premium Accent Gradients */}
      <div className="absolute top-20 right-0 w-[500px] h-[500px] bg-[#1B4D5E]/20 rounded-full blur-[120px]"></div>
      <div className="absolute bottom-40 left-0 w-[400px] h-[400px] bg-[#1A3B4D]/20 rounded-full blur-[100px]"></div>
      
      {/* Subtle Grid Pattern */}
      <div className="absolute inset-0 opacity-[0.02]">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `linear-gradient(to right, #2D5F7A 1px, transparent 1px), linear-gradient(to bottom, #2D5F7A 1px, transparent 1px)`,
            backgroundSize: "60px 60px",
          }}
        ></div>
      </div>

      {/* Top Wave */}
      <svg
        className="absolute top-0 left-0 w-full h-48 rotate-180"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
        preserveAspectRatio="none"
      >
        <path
          fill="#2D5F7A"
          fillOpacity="0.08"
          d="M0,192L48,176C96,160,192,128,288,128C384,128,480,160,576,176C672,192,768,192,864,176C960,160,1056,128,1152,128C1248,128,1344,160,1392,176L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
        ></path>
      </svg>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <motion.div
            initial={{ width: 0 }}
            whileInView={{ width: "80px" }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="h-0.5 bg-gradient-to-r from-[#7BC4E0] to-transparent mx-auto mb-6"
          />
          
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-[#7BC4E0] font-mono text-sm font-semibold tracking-[0.3em] uppercase mb-4 block"
          >
            Why SalaryMates
          </motion.span>
          
          {/* Main Tagline - Concise */}
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="text-3xl md:text-4xl lg:text-5xl font-bold text-white max-w-4xl mx-auto mb-6 leading-tight"
          >
            Stress-free financial support for <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#7BC4E0] to-[#4D9ABF]">working professionals</span>
          </motion.h2>
          
          {/* Single line description - Concise */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="text-lg md:text-xl text-[#CCE6F5] max-w-2xl mx-auto mb-10"
          >
            Quick assistance for unexpected expenses and temporary shortfalls.
          </motion.p>

          {/* Why SalaryMates Grid - Clean 2 Column Layout */}
         {/* Why SalaryMates Grid - 6 Items */}
<motion.div
  initial={{ opacity: 0, y: 20 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true }}
  transition={{ duration: 0.6, delay: 0.5 }}
  className="max-w-3xl mx-auto"
>
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
    {[
      "Quick & Hassle-Free Process",
      "Clear & Transparent Communication",
      "No Confusing Terms",
      "Respectful Customer Experience",
      "Designed for Working Professionals",
      "24/7 Customer Support" // New 6th item
    ].map((item, index) => (
      <motion.div
        key={index}
        initial={{ opacity: 0, x: -20 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.6 + index * 0.1 }}
        className="flex items-center gap-3 bg-gradient-to-br from-[#1A2F3A] to-[#0F2128] px-5 py-4 rounded-xl border border-[#2D5F7A]/30 hover:border-[#7BC4E0]/30 transition-all duration-300 group"
      >
        <div className="w-6 h-6 rounded-full bg-[#7BC4E0]/10 flex items-center justify-center group-hover:bg-[#7BC4E0]/20 transition-colors flex-shrink-0">
          <span className="text-[#7BC4E0] text-sm">✓</span>
        </div>
        <span className="text-[#CCE6F5] text-sm font-medium text-left">{item}</span>
      </motion.div>
    ))}
  </div>
</motion.div>

          {/* Bottom Accent Line */}
          <motion.div
            initial={{ scaleX: 0 }}
            whileInView={{ scaleX: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 1.1 }}
            className="w-24 h-0.5 bg-gradient-to-r from-[#7BC4E0] to-transparent mx-auto mt-12"
          />
        </motion.div>
      </div>

      {/* Bottom Wave */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden pointer-events-none">
        <svg
          className="relative block w-full h-16 md:h-20"
          viewBox="0 0 1440 120"
          preserveAspectRatio="none"
        >
          <path
            fill="#2D5F7A"
            fillOpacity="0.08"
            d="M0,64 C240,96 480,32 720,32 C960,32 1200,96 1440,64 L1440,120 L0,120 Z"
          />
        </svg>
      </div>
    </section>
  );
};

export default WhyChooseUs;